import { render, staticRenderFns } from "./TagAutocomplete.vue?vue&type=template&id=8ccb04e2"
import script from "./TagAutocomplete.vue?vue&type=script&lang=js"
export * from "./TagAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./TagAutocomplete.vue?vue&type=style&index=0&id=8ccb04e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports